// Formato das consultas públicas de propostas (PostgREST), usado pelo site (queries.ts) e
// pelas Pages Functions, que embutem na página os mesmos dados para o React Query
// (src/lib/initial-data.ts). Os dois lados precisam pedir exatamente as mesmas colunas.
// Sem importações: o arquivo também entra no pacote das Functions.

export const LIST_SELECT = `
  id, number, slug, title, summary, status, is_initial, featured, author_label,
  voting_version, latest_revision, published_at, submitted_at, updated_at, category_id,
  category:categories(id, code, slug, name, position),
  stats:proposal_stats(*),
  author:profiles!proposals_author_id_fkey(id, username, display_name, role)
`

export const DETAIL_SELECT = `${LIST_SELECT}, versions:proposal_versions(*), version_results:proposal_version_results(*)`

/** Versões da mais recente para a mais antiga (maior versão, depois maior revisão). */
export function sortVersions<T extends { version_number: number; revision: number }>(versions: readonly T[] | null | undefined): T[] {
  return [...(versions ?? [])].sort((a, b) => b.version_number - a.version_number || b.revision - a.revision)
}

/** Resultados congelados das versões anteriores, da mais recente para a mais antiga. */
export function sortVersionResults<T extends { version_number: number }>(results: readonly T[] | null | undefined): T[] {
  return [...(results ?? [])].sort((a, b) => b.version_number - a.version_number)
}
